const colors = {
  primary:   { 50:'#FAF5F0', 100:'#F4E8DC', 200:'#E8CCBA', 300:'#D9AA8E', 400:'#CC8E6A', 500:'#BC9979', 600:'#A8816A', 700:'#8A6554', 800:'#6E4E40', 900:'#4E352B' },
  secondary: { 50:'#F8F0EC', 100:'#EDD5C8', 200:'#D9A990', 300:'#C47E5A', 400:'#A8603D', 500:'#9A563A', 600:'#844929', 700:'#6A3820', 800:'#4E2815', 900:'#31170B' },
  dark:      { 50:'#ECEDF0', 100:'#C8CAD3', 200:'#9FA2B5', 300:'#777B97', 400:'#555A7B', 500:'#2D3142', 600:'#252838', 700:'#1C1F2C', 800:'#131520', 900:'#0A0B12' },
  background:'#F5F5F5',
  surface:   '#FFFFFF',
  border:    '#E0E0E0',
  divider:   '#F0F0F0',
  text:      { primary:'#1A1A1A', secondary:'#555555', muted:'#888888', disabled:'#BBBBBB' },
  success:   { main:'#4CAF50', bg:'#E8F5E9', text:'#2E7D32' },
  error:     { main:'#F44336', bg:'#FFEBEE', text:'#C62828' },
  warning:   { main:'#FF9800', bg:'#FFF8E1', text:'#E65100' },
  info:      { main:'#2196F3', bg:'#E3F2FD', text:'#1565C0' },
  status: {
    pending:   { bg:'#FFF8E1', text:'#E65100', dot:'#FF9800' },
    confirmed: { bg:'#E8F5E9', text:'#2E7D32', dot:'#4CAF50' },
    arrived:   { bg:'#E3F2FD', text:'#1565C0', dot:'#2196F3' },
    inservice: { bg:'#EDE7F6', text:'#4527A0', dot:'#7E57C2' },
    completed: { bg:'#E0F2F1', text:'#00695C', dot:'#26A69A' },
    cancelled: { bg:'#FFEBEE', text:'#C62828', dot:'#F44336' },
    noshow:    { bg:'#FAFAFA', text:'#616161', dot:'#9E9E9E' },
  },
} as const;

export type Colors = typeof colors;
export default colors;
